import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import DayPanel from "@/components/DayPanel";

export default function DayDetailsDialog({ open, onOpenChange, selectedDate, events, onEventsChanged }) {
  if (!selectedDate) return null;
  const dateLabel = selectedDate.toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  });
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-2xl max-h-[90vh] overflow-y-auto rounded-2xl p-0"
        data-testid="day-details-dialog"
      >
        <DialogHeader className="px-6 pt-6 pb-2">
          <DialogTitle className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight">
            {dateLabel}
          </DialogTitle>
          <DialogDescription>
            Everything you've planned and want to get done on this day.
          </DialogDescription>
        </DialogHeader>
        <div className="px-3 sm:px-4 pb-4">
          <DayPanel
            selectedDate={selectedDate}
            events={events}
            onEventsChanged={onEventsChanged}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
